import io from "socket.io-client";

const SocketClient = io.connect("/", {
  path: "/socket.io",
  transports: ["websocket", "polling"],
  reconnection: true,
});
SocketClient.on("connect", () => {});

SocketClient.on("connect_error", () => {});
export default SocketClient;
